export default __webpack_public_path__ + "static/media/cotent2_3.6ccf1071.png";